module.exports = __webpack_public_path__ + "static/media/header_begegnung_treff.1837e771.jpg";